import { BarChart } from '@mui/icons-material';
import { Box } from '@mui/material';
import PollController from '../../PollController';

interface PollVotesProps {
    votes: number;
}

const PollVotes = (props: PollVotesProps): JSX.Element => {
    return (
        <>
            {/* HP2 */}
            <Box className='poll-votes'>
                <BarChart />
                {PollController.numberToShortString(props.votes)} votes
            </Box>
        </>
    );
};

export default PollVotes;
